import { Component, OnInit } from '@angular/core';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { EntertainmentService } from '../entertainment.service';
import { environment } from '../../../../../../src/environments/environment';
import { SelectionInfo } from 'src/app/post-login/selectors/multi-selection/multi-selection.model';
import { HaloToastService, EToastType } from 'src/app/core/halo-toast/halo-toast.service';
import { HaloCustomLoaderErrorType } from 'src/app/core/halo-custom-loader/halo-custom-loader.service';
import { ZENDESK_ARTICLES } from 'src/app/core/data/constants';

@Component({
  selector: 'app-entertainment-iptv',
  templateUrl: './entertainment-iptv.component.html',
  styleUrls: ['./entertainment-iptv.component.scss']
})
export class EntertainmentIptvComponent implements OnInit {
  rootScopeData: RootScopeDeclare;
  activatedComponentRef: any;
  active: number;
  haloWebCloudURL: string = environment.haloWebCloudBasePath;
  selectionInfo: SelectionInfo;
  hasEditPermission = false;

  iptvEntertainmentData: any;
  defaultIPTVTempData = {
    isEnabledEdited: "false",
    name: "",
    rowNumber: "",
    url: "",
    invalidUrl:true,
    onUpdateClicked:false
  };
  iptvTempData:any;
  onAddClicked = false;
  tvChannelList: any;
  originalTvChannelList:any;
  isChannelListAvailable = false;
  showDisableTvEntertainmentPopup: any;
  isTvDisablePublished: any;
  hasADraft: any;
  isTVEnabled = 'false';
  selectedRowNumberToDelete:any;
  sub = new Subscription();
  disabledPopupProperties = {
    title: this._commonUtil.replaceValueAsHTMLOnTranslatedText('DISABLE.TV.IPTV.SETTINGS', ["IPTV"]),
    message: this._commonUtil.replaceValueAsHTMLOnTranslatedText('DISABLE.TV.IPTV.SETTINGS.MSG', ["IPTV","IPTV","IPTV"]),
    isWarningPopup: false,
    ctaButtonLabel: 'PUBLISH',
    negativeButtonLabel: 'CANCEL',
    isSecondaryTextButton: true,
  };
  enabledPopupProperties = {
    title: this._commonUtil.replaceValueAsHTMLOnTranslatedText('ENABLE.TV.IPTV.POPUP.TITLE', []),
    message: this._commonUtil.replaceValueAsHTMLOnTranslatedText('ENABLE.TV.IPTV.POPUP.MESSAGE', []),
    isWarningPopup: false,
    ctaButtonLabel: 'YES.CONTINUE',
    negativeButtonLabel: 'CANCEL',
    isSecondaryTextButton: true,
  };
  deletePopupProperties = {
    title: this._commonUtil.replaceValueAsHTMLOnTranslatedText('GENERIC.DELETE.TITLE', ["IPTV"]),
    message: this._commonUtil.replaceValueAsHTMLOnTranslatedText('DELETE.MODAL.MESSAGE', []),
    isWarningPopup: true,
    ctaButtonLabel: 'DELETE',
    negativeButtonLabel: 'CANCEL',
    isSecondaryTextButton: true,
  };
  showDisableModal: boolean = false;
  showEnableModal: boolean = false;
  showDeleteModal: boolean = false;
  customLoaderIsLoading = false;//customLoaderIsLoading for customSpinner.
  customLoaderErrorMsg:string;
  customLoaderRedirectButtonLabel:string;
  customLoaderRedirectButtonUrl:string;

  isTVChannelListEdited = false;
  zendeskArticles = ZENDESK_ARTICLES;
  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _rootScopeService: RootScopeService,
    private _facilityService: FacilityService,
    private _commonUtil: CommonUtil,
    private _entertainmentService: EntertainmentService,
    private _toast: HaloToastService,
  ) {
    this.iptvTempData = JSON.parse(JSON.stringify(this.defaultIPTVTempData));
   }

  ngOnInit(): void {
  }

  onSelectionChange(selectionInfo: SelectionInfo) {
    setTimeout(() => {
      if(selectionInfo){
        this.selectionInfo = selectionInfo;
        this.hasEditPermission = this.selectionInfo.facility.summary?.isLoggedInManagerAdmin === 'true' ||
        this.selectionInfo.facility.summary?.userRights.customize === 'F';
        let consoleRights = this._commonUtil.rootScopeData?.consoleRights?.get(this.selectionInfo.consoleType);
        if(consoleRights.hasTVSetting === 'true'){
          this.getIPTVEntertainmentData();
        }
      }
    });
  }
  
  async getIPTVEntertainmentData() {
    this.customLoaderIsLoading = true;
    var payload = { "facilityIds": this.selectionInfo.facility.facilityId.split(',')[0], "consoleType": this.selectionInfo.consoleType };
    try{
      let resp: any = await this._entertainmentService.getIPTVEntertainmentData(payload);
      this.customLoaderIsLoading = false;
      if (resp && resp.iptvSettingsList[0]) {
        resp.iptvSettingsList[0].iptvSettingsVOList?.forEach((element:any) => {
          element.isEnabledEdited = "false";
          element.onUpdateClicked = false;
        });;
        this.iptvEntertainmentData = resp.iptvSettingsList[0];
        this.originalTvChannelList = this.iptvEntertainmentData.iptvSettingsVOList?this.iptvEntertainmentData.iptvSettingsVOList:[];
        this.tvChannelList = JSON.parse(JSON.stringify(this.originalTvChannelList));
        this.isChannelListAvailable = this.tvChannelList ? true : false;
        this.isTVEnabled = this.iptvEntertainmentData.tvEnabled;
      }
    }catch(error){
      this.customLoaderErrorMsg =  HaloCustomLoaderErrorType.APIFAILED;
    }
  }

  prepareIPTVEntertainmentData(iptvEntertainmentData:any):any{
    let data = iptvEntertainmentData;
    let data2 =  data.iptvSettingsVOList.forEach((element:any) => {
      element.isEnabledEdited = "false";
    });
    return data2;
  }

  prepareTVChannelList(tvChannelList:any){
    let list : {}[] = [];
    tvChannelList.forEach((element:any,index:number) => {
      list.push({
        name:element.name,
        url:element.url,
        rowNumber:(index+1).toString()
      })
    });
    return list;
  }

  async publishIPTVEntertainment(action:string) {
    if(action === 'PUBLISH'){
      if(this.validateIsEnabledEdited()){
        return;
      }
    }
    this.customLoaderIsLoading = true;
    this.customLoaderErrorMsg = "";
    this.iptvEntertainmentData.consoleType = this.selectionInfo.consoleType;
    this.tvChannelList = this.tvChannelList.filter((val:any) => val.name && val.url);
    let payload : any; 

    let iptvSettingsVOList = this.prepareTVChannelList(this.tvChannelList);
    
    if(iptvSettingsVOList.length>0){
      payload  = {
        consoleType: this.iptvEntertainmentData.consoleType,
        facilityId:this.iptvEntertainmentData.facilityId,
        tvEnabled: action === "PUBLISH" ? "true" : "false",
        iptvSettingsVOList: iptvSettingsVOList
      };
    }else{
      payload  = {
        consoleType: this.iptvEntertainmentData.consoleType,
        facilityId:this.iptvEntertainmentData.facilityId,
        tvEnabled: action === "PUBLISH" ? "true" : "false",
      }
    }
    
    try {
      let resp: any = await this._entertainmentService.postIPTVSetting(payload);
      this.customLoaderIsLoading = false;
      if (resp) {
        if(resp.iptvSettingsVOList){
          resp.iptvSettingsVOList.forEach((element:any) => {
            element.isEnabledEdited = "false";
          });
        }        
        this.iptvEntertainmentData = resp;
        this.originalTvChannelList = this.iptvEntertainmentData.iptvSettingsVOList?this.iptvEntertainmentData.iptvSettingsVOList:[];
        this.tvChannelList = JSON.parse(JSON.stringify(this.originalTvChannelList));
        this.isChannelListAvailable = this.tvChannelList ? true : false;
        this.isTVEnabled = this.iptvEntertainmentData.tvEnabled;

        var publishOkay = this._commonUtil.replaceValueAsHTMLOnTranslatedText('ENTERTAINMENT.TABS.PUBLISH.SUCCESS.MESSAGE', [this._commonUtil.translateText('IPTV')]);
        if (this.iptvEntertainmentData.tvEnabled === "false") {
          this.isTvDisablePublished = true;
          this.closeDisableTvPopup();
          publishOkay = this._commonUtil.replaceValueAsHTMLOnTranslatedText('ENTERTAINMENT.TV.IPTV.DISABLE.SUCCESS.MESSAGE', [this._commonUtil.translateText('IPTV')]);
        }
        this.hasADraft = false;
        this._toast.creatToast(this._commonUtil.replaceValueAsHTMLOnTranslatedText(publishOkay, []), EToastType.SUCCESS);
        this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = false;
      }
    } catch (error) {
      this.customLoaderErrorMsg =  HaloCustomLoaderErrorType.APIFAILED;
    }
  }


  closeDisableTvPopup() {
    this.showDisableTvEntertainmentPopup = false;
    this.iptvEntertainmentData.tvEnabled = this.isTvDisablePublished ? "false" : "true";
  }

  
  restrictCharsInTvIptvDetails(txtType:string,tvModel:any) {
    if(txtType == 'name'){
      tvModel.name = this.replaceQuotesAndSlash(tvModel.name);
    }else{
      tvModel.url = this.replaceQuotesAndSlash(tvModel.url);
    }
	}
	
	replaceQuotesAndSlash(str:any) {
		str = str.replace(/"/g, '');
		str = str.replace(/\\/g, '');
		return str;
	}

  onChannelNameInputKeyPress(event: KeyboardEvent) {
    if(event.keyCode === 34 || event.keyCode === 92){
      event.preventDefault();
    }else{
      this.hasADraft = true;
    }
  }

  onToggleEnableDisable(enableFlag: boolean): void {
    this.iptvEntertainmentData.tvEnabled = String(enableFlag);
    if(!enableFlag){
      this.showDisableModal = true;
    }else{
      this.showEnableModal = true;
    }
    this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
    this.hasADraft = true;
  }

  onPositiveConfirmation() {
    this.showDisableModal = false;
    this.iptvEntertainmentData.tvEnabled = "false";
    this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
    this.publishIPTVEntertainment('DISABLE');
  }

  closeDisabledModal() {
    this.iptvEntertainmentData.tvEnabled = "true";
    this.showDisableModal = false;
  }

  onEnablePositiveConfirmation() {
    this.showEnableModal = false;
    this.iptvEntertainmentData.tvEnabled ="true";
    this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
  }

  closeEnabledModal() {
    this.iptvEntertainmentData.tvEnabled = "false";
    this.showEnableModal = false;
  }

  learnMore() {
    window.open(this.zendeskArticles.FACILITY_CONNECT_IPTV_PAGE_OVERVIEW, '_blank');
  }

  onADDIPTV(){
    this.onAddClicked = true;
    if(this.iptvTempData.name && this.iptvTempData.url && this.iptvTempData.url.length < 257){
      if(this.validateUrl(this.iptvTempData.url)){
        this.iptvTempData.invalidUrl = false;
        let tmpData = {
          isEnabledEdited: "false",
          name: this.iptvTempData.name,
          rowNumber: new Date().getTime() / 1000 + Math.random(),
          url: this.iptvTempData.url,
          onUpdateClicked:false,
          invalidUrl:this.iptvTempData.invalidUrl,
        };
        this.tvChannelList.unshift(JSON.parse(JSON.stringify(tmpData)));
        this.originalTvChannelList.unshift(JSON.parse(JSON.stringify(tmpData)));
        this.iptvTempData = JSON.parse(JSON.stringify(this.defaultIPTVTempData));
        this.onAddClicked = false; 
      }else{
        this.iptvTempData.invalidUrl = true;
      }
     
    }
    this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
  }

  onIPTVActionButtonClick(action:string,item:any,index:number){
    if(action === 'DELETE'){
      this.showDeleteModal = true;
      this.selectedRowNumberToDelete = item.rowNumber;
      this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
    }
  }

  onDeleteConfirmation() {
    this.showDeleteModal = false;
    this.originalTvChannelList = this.originalTvChannelList.filter((val:any) => val.rowNumber !== this.selectedRowNumberToDelete);
    this.tvChannelList = this.tvChannelList.filter((val:any) => val.rowNumber !== this.selectedRowNumberToDelete);
  }

  closeDeletedModal() {
    this.showDeleteModal = false;
  }

  onIPTVActionBarClick(action:string,item:any,index:number){
    if(action === 'CANCEL'){
      let selectedOriginalTVList =  this.originalTvChannelList.find((val:any) => val.rowNumber === item.rowNumber)
      this.tvChannelList.forEach((element:any) => {
          if(element.rowNumber === item.rowNumber){
            element.name = selectedOriginalTVList.name;
            element.rowNumber = selectedOriginalTVList.rowNumber;
            element.url = selectedOriginalTVList.url;
            element.invalidUrl = selectedOriginalTVList.invalidUrl;
            element.isEnabledEdited = "false";
            element.onUpdateClicked = false;
          }
      });
    }else if(action === 'UPDATE'){
      this.tvChannelList.forEach((element:any) => {
        if(element.rowNumber === item.rowNumber){
          if(element.name && element.url && element.url.length < 257){
            if(this.validateUrl(element.url)){
              element.invalidUrl = false;
              element.isEnabledEdited = "false";
              element.onUpdateClicked = false;
            }else{
              element.invalidUrl = true;
              element.onUpdateClicked = true;
            }
            
          }else{
            element.onUpdateClicked = true;
          }     
        }
      });
      if(item.name && item.url && item.url.length < 257){
        this.originalTvChannelList.forEach((element:any) => {
          if(element.rowNumber === item.rowNumber){
            element.isEnabledEdited = "false";
            element.name = item.name;
            element.invalidUrl = item.invalidUrl;
            element.rowNumber =  item.rowNumber;
            element.url = item.url;
            element.onUpdateClicked = false;
          }
        });
      }
    }
  }

  validateIsEnabledEdited() {    
    this.tvChannelList.forEach((element:any) => {
      if(element.name && element.url && element.url.length < 257){
        element.isEnabledEdited = "false";
        element.onUpdateClicked = false;
      }else{
        element.onUpdateClicked = true;
      } 
    });

    const data = this.tvChannelList.find((val:any) => val.isEnabledEdited === 'true');
    if(data){
      return true;
    }else{
      return false;
    }
  }

  validateUrl(url: any) {
    let status = /^(https?|tcp|udp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(url);
    if(!status){
      let tmp = url.split(':');
      if(tmp.length>1 && tmp[0] === 'udp' && tmp[1] === '//@'){
        status = true;
      }      
    }
    return status;
  }

  ngOnDestroy(): void {
  }

}
